// extracted by mini-css-extract-plugin
export default {"Container":"InfoBox_Container__r7XsD"};